export class VnskySupportOcsInfoToken {
  static VnskySupportOcsInfoViewModel = Symbol("VnskySupportOcsInfoViewModel");
  static IVnSkyOscLookupRepository = Symbol("IVnSkyOscLookupRepository");
  static VnSkyOscLookupUseCase = Symbol("VnSkyOscLookupUseCase");
}
